import { supportLinks } from '@va/constants';
import { useTranslate } from '@va/localization';
import { fontWeights, Paragraph, paragraphSizes } from '@va/ui/design-system';

export const LearnAboutVisitsParagraph = () => {
  const translate = useTranslate();
  return (
    <a className='flex-1 w-fit' rel='noreferrer' target='_blank' href={supportLinks.pricing}>
      <Paragraph
        weight={fontWeights.medium}
        size={paragraphSizes.tiny}
        colorClassName='text-gray-devil'
        className='hover:underline'
      >
        {translate('standalone.upgrade.learnAboutVisits')}
      </Paragraph>
    </a>
  );
};
